// スクロール検知によるフェードインアニメーション
document.addEventListener('DOMContentLoaded', function() {
  // ページロード完了後に背景画像を表示
  const pageWrapper = document.querySelector('.page-wrapper');
  if (pageWrapper) {
    // 背景画像の読み込みを待つ
    const bgImage = new Image();
    // Webpackで処理された画像のパスを使用（HTMLから見た相対パス）
    const bgImagePath = require('../img/bg_yukooshima.png');
    // publicPathが'./'なので、画像パスに'./assets/'を追加
    const path = typeof bgImagePath === 'string' ? bgImagePath : (bgImagePath.default || bgImagePath);
    bgImage.src = './assets/' + path.replace(/^\.\//, '');
    bgImage.onload = function() {
      pageWrapper.classList.add('is-loaded');
    };
    // エラー時も表示（画像読み込みに失敗した場合でも背景色は表示される）
    bgImage.onerror = function() {
      pageWrapper.classList.add('is-loaded');
    };
  }
  
  // 初期表示時のフェードインアニメーション（順番に表示）
  const kvBg = document.getElementById('kv-bg');
  const headerLogo = document.querySelector('.header__logo');
  const mvTitleText1 = document.querySelector('.mv__title__text-1');
  const mvTitleText2 = document.querySelector('.mv__title__text-2');
  const mvScroll = document.querySelector('.mv__scroll');
  
  // 背景画像の読み込み完了を待ってからアニメーション開始
  const startFadeInAnimation = () => {
    // 1. #kv-bg を最初（0秒）に表示
    if (kvBg) {
      kvBg.classList.add('is-visible');
    }
    
    // 2. .header__logo を0.5秒後に表示
    setTimeout(() => {
      if (headerLogo) {
        headerLogo.classList.add('is-visible');
      }
    }, 1000);
    
    // 3. .mv__title__text-1 を1.0秒後に表示
    setTimeout(() => {
      if (mvTitleText1) {
        mvTitleText1.classList.add('is-visible');
      }
    }, 1500);
    
    // 4. .mv__title__text-2 を1.5秒後に表示
    setTimeout(() => {
      if (mvTitleText2) {
        mvTitleText2.classList.add('is-visible');
      }
    }, 2100);
    
    // 5. .mv__scroll を2.0秒後に表示
    setTimeout(() => {
      if (mvScroll) {
        mvScroll.classList.add('is-visible');
      }
    }, 3000);
  };
  
  if (kvBg) {
    // 画像が既に読み込まれている場合（キャッシュなど）
    if (kvBg.complete && kvBg.naturalHeight !== 0) {
      // すぐにアニメーション開始
      startFadeInAnimation();
    } else {
      // 画像の読み込み完了を待つ
      kvBg.addEventListener('load', startFadeInAnimation);
      
      // エラー時のフォールバック（画像読み込みに失敗した場合でも表示）
      kvBg.addEventListener('error', startFadeInAnimation);
    }
  } else {
    // kv-bgが存在しない場合でもアニメーション開始
    startFadeInAnimation();
  }

  // フェードイン対象の要素を取得
  const fadeElements = document.querySelectorAll('.js-fade');

  // Intersection Observerのオプション
  const observerOptions = {
    root: null, // ビューポートを基準にする
    rootMargin: '0px 0px -100px 0px', // 要素が100px上に入ったら発火
    threshold: 0.1 // 要素の10%が見えたら発火
  };

  // Intersection Observerのコールバック関数
  const observerCallback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // data-waittime属性から待機時間を取得（デフォルト: 500ms）
        const waitTime = entry.target.dataset.waittime 
          ? parseInt(entry.target.dataset.waittime, 10) 
          : 500;
        // 要素がビューポートに入ってから指定時間後にis-visibleクラスを追加
        setTimeout(() => {
          entry.target.classList.add('is-visible');
        }, waitTime);
        // 一度表示されたら監視を停止（パフォーマンス向上）
        observer.unobserve(entry.target);
      }
    });
  };

  // Intersection Observerのインスタンスを作成
  const observer = new IntersectionObserver(observerCallback, observerOptions);

  // 各要素を監視対象に追加
  fadeElements.forEach(element => {
    observer.observe(element);
  });
});
